import {
  MODULE_NAME,
  NOTIFICATION
} from './constants'
import * as R from 'ramda'

const buildNotification = R.curry((type, action) => {
  return {
    ...action,
    [MODULE_NAME]: type
  }
})

const buildNotificationAction = R.curry((type, actionCreator) => R.compose(
  buildNotification(type),
  actionCreator,
))

const notifyError = buildNotificationAction(NOTIFICATION.ERROR)
const notifyInfo = buildNotificationAction(NOTIFICATION.INFO)
const notifySuccess = buildNotificationAction(NOTIFICATION.SUCCESS)
const notifyWarning = buildNotificationAction(NOTIFICATION.WARNING)

export {
  notifyError,
  notifyInfo,
  notifySuccess,
  notifyWarning
}
